import { Typography, Link } from "@mui/material";
import { getOverrides, MuiMarkdown } from "mui-markdown";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { useState } from "react";

export default function Accommodations() {
  const h3Item = (props) => (
    <Typography
      variant="h4"
      color="secondary.light"
      align="center"
      gutterBottom
    >
      {props.children}
    </Typography>
  );
  const h4Item = (props) => (
    <Typography variant="h5" color="secondary" align="center" gutterBottom>
      {props.children}
    </Typography>
  );
  const h5Item = (props) => (
    <Typography
      variant="h6"
      color="primary.contrastText"
      align="center"
      gutterBottom
      sx={{ fontWeight: "400" }}
    >
      {props.children}
    </Typography>
  );
  const linkItem = (props) => (
    <Link
      href={props.href}
      target="_blank"
      variant="h6"
      color="primary.contrastText"
      align="center"
      gutterBottom
      sx={{ fontWeight: "600" }}
    >
      {props.children}
    </Link>
  );
  const [lightboxImages, setLightboxImages] = useState([]);
  const [lightboxOpen, setLightboxOpen] = useState(false);

  const openLightbox = (images) => {
    setLightboxImages(images);
    setLightboxOpen(true);
  };

  return (
    <>
      <Typography variant="h4" color="secondary" align="center" gutterBottom>
        Overnight accommodation
      </Typography>
      <MuiMarkdown
        overrides={{
          ...getOverrides({}),
          h3: { component: h3Item },
          h4: { component: h4Item },
          h5: { component: h5Item },
          a: { component: linkItem },
        }}
      >
        {`
##### We are very excited to be able to provide space for everyone to sleep at the venue after the wedding!

### Rules
##### You must bring your own bedding (sheets, pillow, sleeping bag or blanket)
##### We cannot guarantee any specific requests about sleeping location, but we will do our best
##### If you are drinking, please do not drive. There is lots of space and we will provide breakfast for you.
##### ***DO NOT PLAN TO TAKE A TAXI/UBER HOME, THEY DO NOT OPERATE AT THE VENUE***
<br/>
### Makewin Lodge
##### 14 dorm rooms
##### 2 bunkbeds per dorm room
##### 1 bed per dorm room can be converted to a double bed
`}
      </MuiMarkdown>
      <Link
        variant="body1"
        color="secondary.main"
        onClick={() =>
          openLightbox([
            "https://cdn.prod.website-files.com/647634c8db6da01217ac2fa1/64f64b2617294453f6e867b6_lodge-2023-lake.webp",
            "https://cdn.prod.website-files.com/647634c8db6da01217ac2fa1/64f64f800acbfc277df94040_lodge-dining-seating-lake.webp",
            "https://cdn.prod.website-files.com/647634c8db6da01217ac2fa1/64f64f81ae2995f3af60ba21_lodge-dining-seating.webp",
            "https://cdn.prod.website-files.com/647634c8db6da01217ac2fa1/64f64f8183875cd4fd70f0da_lodge-theatre-seating.webp",
            "https://cdn.prod.website-files.com/647634c8db6da01217ac2fa1/64f64f810240396b411e83d0_lodge-theatre.webp"
          ])
        }
        sx={{ display: "block", textAlign: "center", cursor: "pointer" }}
      >
        View Photos of Makewin Lodge
      </Link>
      <MuiMarkdown
        overrides={{
          ...getOverrides({}),
          h3: { component: h3Item },
          h4: { component: h4Item },
          h5: { component: h5Item },
          a: { component: linkItem },
        }}
      >
        {`
<br/>
### Cabins
##### 8 cabins
##### 6 bunkbeds per cabin (sleeps 12)
##### Cabins are ***NOT*** heated
##### Washrooms and Showers are located in the Makewin Lodge
`}
      </MuiMarkdown>
      <Link
        variant="body1"
        color="secondary.main"
        onClick={() =>
          openLightbox([
            "https://cdn.prod.website-files.com/647634c8db6da01217ac2fa1/653a90e5400701669c69ad12_cabin-exterior.webp",
            "https://cdn.prod.website-files.com/647634c8db6da01217ac2fa1/653a90e54795190d35c31853_cabin-interior.webp",
            "https://cdn.prod.website-files.com/647634c8db6da01217ac2fa1/64f64f829aea95f14abe55fd_cabins-boys.webp",
            "https://cdn.prod.website-files.com/647634c8db6da01217ac2fa1/64f64f8217294453f6ed7a56_cabins-girls-washroom-trailer.webp",
            "https://cdn.prod.website-files.com/647634c8db6da01217ac2fa1/64f64f8183875cd4fd70efa1_cabins-girls.webp"
          ])
        }
        sx={{ display: "block", textAlign: "center", cursor: "pointer" }}
      >
        View Photos of Cabins
      </Link>
      <MuiMarkdown
        overrides={{
          ...getOverrides({}),
          h3: { component: h3Item },
          h4: { component: h4Item },
          h5: { component: h5Item },
          a: { component: linkItem },
        }}
      >
        {`
<br/>
### Tenting
##### There is lots of space to set up a tent
##### You must bring your own tent
<br/>
### Car Camping / RV
##### There are limited parking spots
##### Please let us know in advance so we can accommodate
<br/>
### Hotels
#### Edmonton is a 1 hour 45 min drive
#### Westlock is the closest town with hotels, ~35 min drive
##### [Westlock Inn & Conference Centre](https://maps.app.goo.gl/KwannjtPWQSuzxHRA)
##### [Ramada by Wyndham Westlock](https://maps.app.goo.gl/k2ngohk6Dq5LiArYA)
##### [All Stay Suites](https://maps.app.goo.gl/8Wmwr5V19zcJ23RX8)
<br/>
`}
      </MuiMarkdown>
      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={lightboxImages.map((src) => ({ src }))}
      />
    </>
  );
}
